import { Fill, Stroke, Style } from 'ol/style'
import { heatMap } from '../../../../../utils/colors/chartPalette'

const getDataIntervalFromRange = (range, numBins) => {
    const [dataMin, dataMax] = range
    const diff = dataMax - dataMin
    const interval = diff / numBins
    return interval
}

const getHeatMapColorKeyFromRange = (value, range, configsHeatMap) => {
    // if value is 0,
    // return undefined to give the transparent
    // color in themeMapStyleFunction
    let heatMapArray = configsHeatMap ? configsHeatMap : heatMap
    if (value === 0) {
        return undefined
    }
    const [dataMin] = range
    try {
        const interval = getDataIntervalFromRange(range, heatMapArray.length)
        return heatMapArray
                .map((_, idx) => dataMin + (idx + 1) * interval)
                .findIndex(x => x + 1> value)
        
    } catch (error) {
        const interval = getDataIntervalFromRange(range, heatMap.length)
        return heatMap
                .map((_, idx) => dataMin + (idx + 1) * interval)
                .findIndex(x => x + 1> value)
    }
}

const resolveHeatMapLegendData = (range, targetHeatMap) =>  {
    const [dataMin] = range
    const interval = getDataIntervalFromRange(range, targetHeatMap.length)
    if (interval === NaN || interval === 0 ) {
        return [{
            color: targetHeatMap[0],
            dataMin: dataMin,
            dataMax: null
        }]
    }
    return targetHeatMap.map((_, idx) => {
        return {
            color: targetHeatMap[idx],
            dataMin: Math.ceil(dataMin + (idx * interval)),
            dataMax: Math.ceil(dataMin + ((idx + 1) * interval))
        }
    }).filter(x => x.dataMax - x.dataMin > 0)//WSW-606 We don't want intervals like 50-50 or 2-2 or 14-14
}

const getLegendDataFromRange = (range, configsHeatMap) => {
    let heatMapArray = configsHeatMap ? configsHeatMap : heatMap
    try {
        return resolveHeatMapLegendData(range, heatMapArray)
    } catch (error) {
        return resolveHeatMapLegendData(range, heatMap)
    }
}

function hexToRGB(hex, alpha) {
    let r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha ? alpha : 1})`
}

const getHeatMapStyles = (configsHeatMap, opacity) => {
    let heatMapArray = configsHeatMap ? configsHeatMap : heatMap
    return heatMapArray.map((_, idx) => idx).reduce((acc, current) => {
        let color = heatMapArray[current]
        color = hexToRGB(color, opacity)
        return {
            ...acc,
            [current]: new Style({
                fill: new Fill({
                    color,
                }),
                stroke: new Stroke({
                    color: 'black',
                    width: 1
                }),
            })
        }
    }, {})
}

const defaultCountyStyle = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0)'
    }),
    stroke: new Stroke({
        color: 'black',
        width: 1
    })
})

const themeMapStyleFunction = (feature, configsHeatMap, opacity) => {
    const colorKey = feature.get('ColorKey')
    if (typeof colorKey !== 'undefined') {
        return getHeatMapStyles(configsHeatMap, opacity)[colorKey]
    } else {
        return defaultCountyStyle
    }
}

export { themeMapStyleFunction, getHeatMapColorKeyFromRange, getLegendDataFromRange }